import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'

export const TABLE_TEXT = {
  tableAira: 'App Deadline Cut Off Extensions table',
  email: 'Applicant Email',
  lastName: 'Applicant Last Name',
  deadline: 'App Deadline',
  newCutOff: 'New Cut-Off',
  lastUpdatedBy: 'Updated By',
  actionsAria: 'Actions',
  noExtensions: 'No extensions added yet',
}

const ExtensionsTable = ({ children }: { children: JSX.Element }) => {
  return (
    <TableContainer component={Card}>
      <Table aria-label={TABLE_TEXT.tableAira}>
        <TableHead>
          <TableRow>
            <TableCell>{TABLE_TEXT.email}</TableCell>
            <TableCell>{TABLE_TEXT.lastName}</TableCell>
            <TableCell>{TABLE_TEXT.deadline}</TableCell>
            <TableCell>{TABLE_TEXT.newCutOff}</TableCell>
            <TableCell>{TABLE_TEXT.lastUpdatedBy}</TableCell>
            <TableCell>{TABLE_TEXT.actionsAria}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  )
}

export default ExtensionsTable
